const SLICE_NAME = 'agentModeSlice';

/**
 * HITL-1604: the one global mode that says what the supervising agent is allowed
 * to do while the AI runs the order.
 *
 * `Shadow` is **silent** — nothing the agent does in it reaches the customer or
 * the POS. `Intercept` is the only mode that can speak or send, and it is what
 * today's "agent has taken over" state becomes.
 *
 * Two values, deliberately. An earlier draft had a third, `Supervise`, sitting
 * before `Shadow` as a read-only mode in which the agent could not even build a
 * cart. It was cut before it ever shipped: the agent gains nothing from being
 * refused a scratch cart that never leaves the terminal, and the distinction
 * cost a mode the agent had to reason about mid-order. Shadow is now the
 * resting state, so the enum has no "watching but idle" value — watching IS
 * Shadow.
 *
 * Deliberately NOT a rename of `isAIAutoMode`, and nothing in this feature
 * writes to it: mutating that flag to fix a display symptom caused a production
 * incident (dropped orders + a cart revert).
 */
enum AgentMode {
  shadow = 'Shadow',
  intercept = 'Intercept',
}

/** Every HITL session starts here. There is no persistence — see the slice. */
const DEFAULT_AGENT_MODE = AgentMode.shadow;

export { SLICE_NAME, AgentMode, DEFAULT_AGENT_MODE };
